import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { Button, Grid, Tooltip } from "@mui/material";
//import DrawIcon from '@mui/icons-material/Draw';
import BrushIcon from '@mui/icons-material/Brush';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import { Formik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import { useMutation, useQuery } from "react-query";
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import 'swiper/swiper-bundle.css';
import * as Yup from "yup";
import MaterialTextFieldComponent from '../../../../components/textField/MaterialTextFieldCmp';
import { DashboardIdResponse, DashboardItems, DashboardRequest, IdRequest, UserDashboardItemsRequest } from "../../../../models/dashboard.model";
import { GetGroupsWithSubReportsResponse, Reports } from "../../../../models/pBIReport.model";
import { CreateUserDashboard, DeleteUserDashboard, GetUserDashboards, UpdateUserDashboard, UserDashboardItems } from "../../../../services/dashboard.service";
import { GetGroupsWithSubReports } from "../../../../services/pBIReport.service";
import { toast } from 'react-toastify';
import DeletedUserDashboardModal from '../../../../components/modals/deleteUserDashboardModal';
import { ApiResultModel } from '../../../../models/common.model';
import { Sidebar } from 'react-pro-sidebar';
import { useHistory } from 'react-router';
import ReplayIcon from '@mui/icons-material/Replay';
import Chip from "../../sliderContent/chip";
import LeftSideCard from "../../sliderContent/leftSideCard";
import DehazeIcon from '@mui/icons-material/Dehaze';
import { Paper } from "@material-ui/core";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, InputBase } from "@mui/material";
import useStyles from "../sideBar/sidebarUseStyles";
import Fuse from 'fuse.js';
import UserDashboardItem from '../../../../components/cards/userDashboardItem';
import RGL, { WidthProvider } from "react-grid-layout";
import { uniqueId } from 'lodash';
import { dashboardLoaderSet } from '../../../../redux/dashboardLoader/dashboardLoaderSlice';
import { debug } from 'console';
import { any } from 'prop-types';

interface UserDashboardName {
    name: string;
}

const ReactGridLayout = WidthProvider(RGL);

export default function DashboardPanel() {
    const css = `
    #kt_content {
     padding: 0px !important ;
   }
   .container{
      padding:0px !important;
      max-width:100% !important;
   }
   .MuiTreasury-paper {
    margin-top: 24vh !important;
   }
   .makeStyles-root-45{
    margin-bottom:13vh !important
   }
   .swiper-container{
    width:20% !important;
    
   }
   .swiper{
    margin-right:0px !important;
   }
  `


    const cssSidebar = `
  ::-webkit-scrollbar {
    width: 5px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: #707070; 
  }
   
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #9AAFC4; 
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }

`
    const classes = useStyles();
    const [createDashboard, setCreateDashboard] = useState<boolean>(false);
    const [updateDashboard, setUpdateDashboard] = useState<boolean>(false);
    const [cloneDashboard, setCloneDashboard] = useState<boolean>(false);
    const [deleteDashboard, setDeleteDashboard] = useState<boolean>(false);
    const [reloadDashboard, setReloadDashboard] = useState<boolean>(false);
    const [leftItems, setLeftItems] = useState<any>([]);
    // const [rawLeftItems, setRawLeftItems] = useState<any>([]);
    const [dashboardItemView, setDashboardItemView] = useState<any>([]);
    const [dashboardItemViewTemp, setDashboardItemViewTemp] = useState<any>([]);


    const [userDashboardState, setUserDashboardState] = useState<any>([]);
    const [firstRun, setFirstRun] = useState<boolean>(false);

    const [group, setGroup] = useState<GetGroupsWithSubReportsResponse[]>();
    const [groupID, setGroupID] = useState(0);
    const [selectedUserDashboard, setSelectedUserDashboard] = useState(0);
    const [theCurrentDraggedElement, setTheCurrentDraggedElement] = useState<any>(null);

    const [swiperInstance, setSwiperInstance] = useState<SwiperCore>();

    const [collapsed, setCollapsed] = React.useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    //const userDashboardInitialVal: UserDashboardItemsRequest = { isDefaultPage: false, orderIndex: 0, userDashboardId: undefined, dashboardItems: [], name: "", jsonConfig: "" }
    const [userDashboardInitialNameState, setUserDashboardInitialNameState] = useState<UserDashboardName>({ name: "" } as UserDashboardName);


    // const history = useHistory<{ cloneMode: boolean, editMode: boolean, selectedItem: any }>();
    // const [cloneModeState, setCloneModeState] = useState<any>(
    //     history.location.state != null ? history.location.state.cloneMode : null);
    // const [editModeSate, setEditModeState] = useState<any>(
    //     history.location.state != null ? history.location.state.editMode : null);
    // const [selectedItem, setSelectedItem] = useState<any>(
    //     history.location.state != null ? history.location.state.selectedItem.item : null);

    const fuse = new Fuse(leftItems, {
        keys: ["title"],
        includeScore: true,
        threshold: 0.1,
        ignoreLocation: true,
        useExtendedSearch: true,
    });
    const results = fuse.search(searchTerm);
    const leftItemsWithSearch = searchTerm
        ? results.map((title: any) => title.item)
        : leftItems.sort((a: any, b: any) => a.orderIndex - b.orderIndex);

    const createUserDashboardPage = () => {

        //setLeftItems([...rawLeftItems])
        setUserDashboardInitialNameState({ name: "" } as UserDashboardName)
        setDashboardItemViewTemp([...dashboardItemView]);
        setDashboardItemView([]);

        // dashboardItemView.map((item: any) => {
        //     item.createMode = true;
        //     item.isDeleted = true;
        // })
        // setDashboardItemView(dashboardItemView);

        setCreateDashboard(true);
        setUpdateDashboard(false);
        setCloneDashboard(false);
        setDeleteDashboard(false);

        //getGroupsWithSubReports.mutate();

    }
    const updateUserDashboard = () => {

        //setRightItems([...dashboardItemView]);

        //setLeftItems([...rawLeftItems.map((s: any) => dashboardItemView.find((dItem: any) => dItem.id === s.id) ? { ...s, disable: true } : s)])

        //setLeftItems(rawLeftItems.filter((item: any) => !dashboardItemView.find((dItem: any) => dItem.id === item.id)));

        setUserDashboardInitialNameState({ name: userDashboardState[selectedUserDashboard].name } as UserDashboardName)
        setDashboardItemViewTemp([...dashboardItemView]);

        setCreateDashboard(false);
        setUpdateDashboard(true);
        setCloneDashboard(false);
        setDeleteDashboard(false);
    }
    const cloneUserDashboard = () => {

        //setRightItems([...dashboardItemView]);
        //setLeftItems([...rawLeftItems.filter((item: any) => !dashboardItemView.find((dItem: any) => dItem.id === item.id))]);
        //setLeftItems([...rawLeftItems.map((s: any) => dashboardItemView.find((dItem: any) => dItem.id === s.id) ? { ...s, disable: true } : s)])
        setUserDashboardInitialNameState({ name: "" } as UserDashboardName)
        setDashboardItemViewTemp([...dashboardItemView]);

        setCreateDashboard(false);
        setUpdateDashboard(false);
        setCloneDashboard(true);
        setDeleteDashboard(false);
    }
    const deleteUserDashboardStates = () => {

        setCreateDashboard(false);
        setUpdateDashboard(false);
        setCloneDashboard(false);
        setDeleteDashboard(true);

    }

    const getGroupID = (ID: any) => {
        setGroupID(ID);
    };

    const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value.trim().toLocaleLowerCase());
    };


    const fillDashboardItemViewer = () => {

        if (userDashboardState != undefined && userDashboardState.length > 0) {
            var userDashboardObj = userDashboardState[selectedUserDashboard];
            const userDashboardIdReq = { id: userDashboardObj.userDashboardId } as IdRequest
            getUserDashboardItemsService.mutate(userDashboardIdReq);
        } else {
            setDashboardItemView([]);
        }
    }

    const MINUTE_MS = 300000;


    useEffect(() => {
        const interval = setInterval(() => {

            if (cloneDashboard != true && createDashboard != true && updateDashboard != true) {
                return setReloadDashboard(true);
            }
        }, MINUTE_MS);

        // return () => {
        //     setReloadDashboard(true)
        //     clearInterval(interval);
        // }
    }, []);

    useEffect(() => {
        fillDashboardItemViewer();
    }, [selectedUserDashboard || (firstRun == true)]);

    useEffect(() => {
        if (deleteDashboard) {
            setDeleteDashboard(false)
            fillDashboardItemViewer();
        }
    }, [userDashboardState]);


    useEffect(() => {
        if (reloadDashboard == true && cloneDashboard != true && createDashboard != true && updateDashboard != true) {
            var userDashboardObj = userDashboardState[selectedUserDashboard];
            const userDashboardIdReq = { id: userDashboardObj.userDashboardId } as IdRequest
            getUserDashboardItemsService.mutate(userDashboardIdReq);
            //setReloadDashboard(false)
        }
    }, [reloadDashboard]);

    useQuery<GetGroupsWithSubReportsResponse[]>(
        "GetGroupsWithSubReports",
        (): Promise<GetGroupsWithSubReportsResponse[]> => {
            return GetGroupsWithSubReports();
        },
        {
            onSuccess: (data) => {

                if (data != null && data.length > 0) {
                    let counter = 0;
                    var reports = [] as Reports[];
                    data.forEach(groupItem => {

                        let totalCount = groupItem.reports.length;
                        if (totalCount !== 0) {
                            groupItem.reports.map((item: any) => {

                                item.x = 0;
                                item.y = 0;
                                item.w = 12;
                                item.h = 2;
                                item.disable = false;
                                item.groupId = groupItem.id;
                                item.i = counter;
                                reports.push(item);
                                counter++;
                            });
                        }
                    });
                    //setRawLeftItems(reports);
                    setLeftItems(reports);
                    setGroup(data);
                    setGroupID(data[0].id);


                }
            }
        },
    );

    const createUserDashboardService = useMutation(CreateUserDashboard, {
        onSuccess: (data: DashboardIdResponse) => {
            if (data != null) {
                //TODO-> Add to userDashboards
                const userDashboardItem = { isDefaultPage: false, userDashboardId: data.userDashboardId, name: userDashboardInitialNameState.name } as DashboardRequest;
                userDashboardState.push(userDashboardItem);
                setSelectedUserDashboard(userDashboardState.length - 1);
                setCreateDashboard(false)
                setCloneDashboard(false);

            }
        },
        onError: () => { },
    });

    const updateUserDashboardService = useMutation(UpdateUserDashboard, {
        onSuccess: (data: boolean) => {
            if (data) {
                //TODO-> Add to userDashboards

                setUpdateDashboard(false)
                toast.success("ویرایش اطلاعات با موفقیت انجام شد.");

                let updatedUserDashboard = userDashboardState.map((el: any) => (el.userDashboardId === userDashboardState[selectedUserDashboard].userDashboardId ? { ...el, name: userDashboardInitialNameState.name } : el))
                setUserDashboardState(updatedUserDashboard);

                const dashboardItemViewTemp = dashboardItemView.slice();
                dashboardItemViewTemp.map((item: any, index: any) => {
                    if (item.isTemporary != undefined && item.isTemporary == true) {
                        dashboardItemViewTemp[index].isTemporary = undefined;
                    }
                })
                setDashboardItemView(dashboardItemViewTemp);

                // setDashboardItemView(rightItems);

            } else {
                toast.error("خطا در ویرایش اطلاعات")
            }
        },
        onError: () => { },
    });

    const getUserDashboardItemsService = useMutation(UserDashboardItems, {
        onSuccess: (data: DashboardItems[]) => {
            if (data != null) {
                //TODO-> Add to userDashboards


                let rightData: any[] = [];
                let counter = 0;
                data.map((item: any) => {
                    let jsonConfig = JSON.parse(item.jsonConfig);
                    let rightObj = { i: counter, id: item.pbiReportId, title: item.title, url: item.url, disable: true, x: jsonConfig.x, y: jsonConfig.y, w: jsonConfig.w, h: jsonConfig.h, isTemporary: undefined, isDeleted: undefined, createMode: undefined, tempX: undefined, tempY: undefined, tempW: undefined, tempH: undefined }

                    rightData.push(rightObj);
                    counter++;

                })
                setDashboardItemView(rightData);

                setReloadDashboard(false);

            }
        },
        onError: () => { },
    });

    const deleteUserDashboardService = useMutation(DeleteUserDashboard, {
        onSuccess: (data: ApiResultModel<boolean>) => {
            if (data != null && data.data) {
                //TODO-> Add to userDashboards
                toast.success("حذف اطلاعات با موفقیت انجام شد.");
                setSelectedUserDashboard(0);
                swiperInstance?.slideTo(0);
                let selectedUserDashboardId = userDashboardState[selectedUserDashboard].userDashboardId;
                let remianedUserDashboard = userDashboardState.filter((e: any) => e.userDashboardId != selectedUserDashboardId);
                //userDashboardState.filter((item: any) => { item.userDashboardId != userDashboardState[selectedUserDashboard].userDashboardId });
                setUserDashboardState(remianedUserDashboard);

                //setDashboardItemView(rightItems);

            } else {
                toast.error("خطا در حذف اطلاعات")
            }
        },
        onError: () => { },
    });

    const deleteUserDashboardHandler = () => {
        let idRequest = { id: userDashboardState[selectedUserDashboard].userDashboardId } as IdRequest
        deleteUserDashboardService.mutate(idRequest);
    }



    let { data, isLoading } = useQuery<DashboardRequest[]>(
        "GetUserDashboards",
        (): Promise<DashboardRequest[]> => {
            return GetUserDashboards();
        },
        {
            onSuccess: (data) => {

                if (!((data != null && data.length == 0) || data == null)) {
                    setUserDashboardState(data);
                    setFirstRun(true);
                }
            }
        },
    );
    const cancelCreateUserDashboard = () => {


        // const temporayDashboardItems = dashboardItemView.filter((item: any) => (item.isTemporary != true));
        // const layout = temporayDashboardItems.map((item: any) => ({ ...item }));

        // layout.map((item: any) => {
        //     item.isDeleted = undefined;
        //     item.isTemporary = undefined;
        //     item.createMode = undefined;
        //     if (item.tempX != undefined) {
        //         item.x = item.tempX;
        //         item.y = item.tempY;
        //         item.w = item.tempW;
        //         item.h = item.tempH;
        //         item.tempX = undefined;
        //         item.tempY = undefined;
        //         item.tempW = undefined;
        //         item.tempH = undefined;
        //     }
        // })
        setDashboardItemView([...dashboardItemViewTemp]);

        // let dashboardItemTemps = dashboardItemView.filter((item: any) => (item.isTemporary == undefined || item.isTemporary == true) || (item.isDeleted == undefined || item.isDeleted == true));
        // if (dashboardItemTemps != undefined && dashboardItemTemps != null && dashboardItemTemps.length > 0) {
        //     const temporayDashboardItems = dashboardItemView.filter((item: any) => (item.isTemporary != true));

        //     temporayDashboardItems.map((item: any) => {
        //         item.isDeleted = undefined;
        //     })
        //     setDashboardItemView(temporayDashboardItems);

        // }

        setCreateDashboard(false);

        setCloneDashboard(false);
        setUpdateDashboard(false);

    }

    const nameValidation = Yup.object().shape({
        name: Yup.string()
            .required("فیلد اجباری می باشد")
    });



    {/* <SlideText names={userDashboardState}></SlideText> */ }



    const reloadPage = () => {
        //window.location.reload();
        setReloadDashboard(true);
    }

    const onDrop = (layout: any, layoutItem: any, _event: any) => {

        handleFromOutsideDrag(layoutItem);
    };

    const handleFromOutsideDrag = (
        newItem: any
    ) => {

        getPosition();

        let addedItemToTheLeftSideTmp = { ...theCurrentDraggedElement }
        addedItemToTheLeftSideTmp.isTemporary = true;
        addedItemToTheLeftSideTmp.i = dashboardItemView.length - 1;
        addedItemToTheLeftSideTmp.h = 3;
        addedItemToTheLeftSideTmp.w = 4;
        addedItemToTheLeftSideTmp.y = newItem.y;
        addedItemToTheLeftSideTmp.x = newItem.x;
        setDashboardItemView([...dashboardItemView, addedItemToTheLeftSideTmp]);

        setTheCurrentDraggedElement(null);
    };
    const boxRef = useRef<HTMLDivElement>(null);
    const getPosition = () => {
        const x = boxRef.current?.offsetLeft;
    };

    const handleDrag = (
        layout: any,
        oldItem: any,
        newItem: { i: any; x: any; y: any; w: any; h: any }
    ) => {

        getPosition();

        let layoutTemp: any[] = [];

        dashboardItemView.map((item: any, idx: any) => {
            layoutTemp.push(item);
        });


        let selectedRightItem = layoutTemp.findIndex((x: any) => x.i == newItem.i);
        if (selectedRightItem == undefined)
            return;

        layoutTemp[selectedRightItem].w = newItem.w;
        layoutTemp[selectedRightItem].h = newItem.h;
        layoutTemp[selectedRightItem].x = newItem.x;
        layoutTemp[selectedRightItem].y = newItem.y;

        setDashboardItemView(layoutTemp);
    };

    const deleteItem = (item: any, index: any) => {


        if (!item?.id)
            return;

        setDashboardItemView((oldArray: any) => { return oldArray.filter((value: any, i: any) => i != index) });
    };

    const onLayoutChange = (layout: any) => {

    }

    const viewHeight = window.outerHeight;

    return (
        <div className="m12" style={{ direction: "ltr" }}>
            <style>{css}</style>
            <Formik
                initialValues={userDashboardInitialNameState}
                validateOnMount={true}
                validationSchema={nameValidation}
                enableReinitialize={true}
                onSubmit={(values, { resetForm }) => {



                    let userDashboardTemp = { isDefaultPage: false, orderIndex: 0, userDashboardId: undefined, dashboardItems: [], name: values.name, jsonConfig: "" } as UserDashboardItemsRequest;
                    dashboardItemView.map((item: any) => {
                        let userDashboardItem: DashboardItems = { pbiReportId: item.id, jsonConfig: JSON.stringify({ h: item.h, w: item.w, x: item.x, y: item.y }), isTemporary: false, isDeleted: false }
                        userDashboardTemp.dashboardItems.push(userDashboardItem);
                    })
                    setUserDashboardInitialNameState({ name: values.name } as UserDashboardName)
                    if (createDashboard == true || cloneDashboard == true) {
                        createUserDashboardService.mutate(userDashboardTemp);
                    } else if (updateDashboard == true) {
                        userDashboardTemp.userDashboardId = userDashboardState[selectedUserDashboard].userDashboardId;
                        updateUserDashboardService.mutate(userDashboardTemp)
                    }

                }}
            >
                {({ handleSubmit, handleChange, values, errors, touched, handleBlur, setFieldValue }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid container
                            style={{ direction: "rtl", paddingTop: "5px" }}
                            xs={12}
                            columns={{ xs: 4, sm: 8, md: 10, lg: 12 }}
                            className="dashboardCRUDPart">
                            <Grid container item xs={7}  >
                                {updateDashboard == true || cloneDashboard == true ? <></> :
                                    <Tooltip title="افزودن">
                                        <Button id="addBtn" className={createDashboard ? "dashboardCRUDButton selected-dashboardCRUDPart-button" : "dashboardCRUDButton unselected-dashboardCRUDPart-button"} onClick={createUserDashboardPage}>
                                            <AddCircleOutlineIcon className={createDashboard ? "dashboardCRUDIcon selected-dashboardCRUDPart_Icon" : "dashboardCRUDIcon unselected-dashboardCRUDPart_Icon"} />
                                        </Button>
                                    </Tooltip>
                                }
                                {createDashboard == true ?
                                    <></> :
                                    //TODO-> remove this part and get it from props-> (from managerDashboardPage)
                                    (userDashboardState != null && userDashboardState.length > 0) ?
                                        <>
                                            {cloneDashboard == true ? <></> :
                                                <Tooltip title="ویرایش">
                                                    <Button id="editBtn" className={updateDashboard ? "dashboardCRUDButton selected-dashboardCRUDPart-button" : "dashboardCRUDButton unselected-dashboardCRUDPart-button"} onClick={updateUserDashboard}>
                                                        <ModeEditIcon className={updateDashboard ? "dashboardCRUDIcon selected-dashboardCRUDPart_Icon" : "dashboardCRUDIcon unselected-dashboardCRUDPart_Icon"} />
                                                    </Button>
                                                </Tooltip>
                                            }
                                            {updateDashboard == true ? <></> :
                                                <Tooltip title="کپی">
                                                    <Button id="cloneBtn" className={cloneDashboard ? "dashboardCRUDButton selected-dashboardCRUDPart-button" : "dashboardCRUDButton unselected-dashboardCRUDPart-button"} onClick={cloneUserDashboard}>
                                                        <ContentCopyIcon className={cloneDashboard ? "dashboardCRUDIcon selected-dashboardCRUDPart_Icon" : "dashboardCRUDIcon unselected-dashboardCRUDPart_Icon"} />
                                                    </Button>
                                                </Tooltip>
                                            }
                                            {cloneDashboard == true || updateDashboard == true ? <></> :
                                                <DeletedUserDashboardModal deleteUserDashboardStates={deleteUserDashboardStates} dashboardName={userDashboardState[selectedUserDashboard].name} deleteUserDashboard={deleteUserDashboardHandler} deleteDashboard={deleteDashboard} showDeleteBtn={true} />
                                            }
                                            {cloneDashboard == true || updateDashboard == true ? <></> :
                                                <Tooltip title="بارگزاری مجدد">
                                                    <Button id="reloadBtn" className={"dashboardCRUDButton unselected-dashboardCRUDPart-button"} onClick={() => reloadPage()} >
                                                        <ReplayIcon className={"dashboardCRUDIcon unselected-dashboardCRUDPart_Icon"}
                                                        />
                                                    </Button>
                                                </Tooltip>

                                            }

                                            {(userDashboardState.length > 0 && cloneDashboard == false && updateDashboard == false) ?
                                                <div style={{ position: "relative", width: "25%" }}>
                                                    <Tooltip title="بعدی">
                                                        <div className="swiper-button image-swiper-button-next">

                                                            <LastPageIcon style={{ color: "#9AAFC4" }} />
                                                        </div>
                                                    </Tooltip>

                                                    <Tooltip title="قبلی">
                                                        <div className="swiper-button image-swiper-button-prev">
                                                            <FirstPageIcon style={{ color: "#9AAFC4" }} />
                                                        </div>
                                                    </Tooltip>
                                                    <Swiper
                                                        //modules={}
                                                        onSwiper={setSwiperInstance}
                                                        style={{ marginRight: "0px !important" }}
                                                        slidesPerView={1}
                                                        centeredSlides
                                                        onSlideChange={(e) => setSelectedUserDashboard(e.realIndex)}
                                                        initialSlide={selectedUserDashboard}
                                                        observer={true}
                                                        //navigation={true}
                                                        navigation={{
                                                            nextEl: ".image-swiper-button-next",
                                                            prevEl: ".image-swiper-button-prev",
                                                            disabledClass: "swiper-button-disabled"
                                                        }}
                                                        modules={[Navigation]}
                                                        pagination={true}
                                                    >
                                                        {userDashboardState.map((item: any) => {
                                                            return <SwiperSlide >
                                                                <p style={{ marginTop: "5px", fontSize: "18px", color: "#1D4A87" }}>{item.name}</p>
                                                            </SwiperSlide>
                                                        })}

                                                    </Swiper>
                                                </div>
                                                : <></>}
                                        </>
                                        : <></>
                                }
                                {createDashboard == true || updateDashboard == true || cloneDashboard == true ?
                                    <div style={{ paddingTop: "10px" }}>
                                        <MaterialTextFieldComponent
                                            autoFocus={true}
                                            helperText={touched.name ? errors.name : ""}
                                            error={touched.name && Boolean(errors.name)}
                                            placeHolder={"انتخاب نام ..."}
                                            label={"انتخاب نام ..."}
                                            required={true}
                                            value={values.name}
                                            onChange={handleChange}
                                            name="name"
                                            id="name"
                                            onBlur={handleBlur} />
                                    </div> : <></>}

                            </Grid>

                            <Grid container item xs={5}
                                style={{ direction: "ltr", padding: "13px" }}>
                                {createDashboard == true || cloneDashboard == true || updateDashboard == true ?
                                    <>
                                        <Button id="cancelBtn" className="btnForm ComingBack" style={{ width: "165px", height: "36px" }} onClick={() => {
                                            //setFieldValue('name', "")
                                            cancelCreateUserDashboard()
                                        }}> انصراف</Button>
                                        <Button id="submitBtn" type="submit"
                                            disabled={Object.keys(errors).length > 0 || (dashboardItemView == undefined || dashboardItemView == null || dashboardItemView.length == 0)}
                                            className={`${Object.keys(errors).length > 0 || (dashboardItemView == undefined || dashboardItemView == null || dashboardItemView.length == 0)
                                                ? "btnForm disabledBtn  "
                                                : "btnForm SuccessDefault "
                                                }`} style={{ width: "165px", height: "36px", marginLeft: "10px" }} > تایید</Button>

                                    </>
                                    : <></>}
                            </Grid>


                        </Grid>

                    </form>
                )}
            </Formik>
            {(((dashboardItemView == null || dashboardItemView == undefined || dashboardItemView.length == 0) && (createDashboard != true && updateDashboard != true && deleteDashboard != true && cloneDashboard != true))) ?
                <div className="centered">
                    <div >
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingBottom: "2vh" }}>
                            <BrushIcon className="subColor " style={{ width: "48px", height: "48px" }}></BrushIcon>
                        </div>
                        <div className="subColor textFont20  ">.برای طراحی داشبورد مورد نیاز خود دکمه افزودن به لیست بزنید</div>
                    </div>
                </div> : <></>}
            <div style={{ direction: "ltr" }}>

                <Grid container item xs={12} className="customSidebar">

                    {(createDashboard == true || updateDashboard == true || cloneDashboard == true) ?
                        <Grid item xs={collapsed ? 0.3 : 3} md={collapsed ? 0.3 : 2.5} lg={collapsed ? 0.3 : 2.5}
                            id="leftSide"

                        >
                            {/* width="350px" */}
                            {/* SIDEBAR CONTAINER */}
                            <Sidebar className="custom-sidebar" style={{ height: "100%" }} width="100%" transitionDuration={500} collapsedWidth="40px" collapsed={collapsed}>
                                <style>{cssSidebar}</style>
                                <div style={{ height: "100%", overflowY: "auto", direction: "rtl" }} className={classes["sidebarContainer"]}>
                                    {/* maxHeight: "770px",  */}
                                    {/* TOGGLE */}

                                    {/* PAGE LIST */}

                                    {collapsed ?
                                        <>
                                            <div style={{ position: "absolute", bottom: "25px", right: "10px" }}>
                                                <DehazeIcon style={{ color: "#FFFFFF" }} onClick={() => setCollapsed(!collapsed)} />
                                            </div>
                                        </> :
                                        <>
                                            <Grid>

                                                <div style={{ width: "86%", marginRight: "7%", marginLeft: "7%", marginTop: "-20px", marginBottom: "10px" }}>
                                                    <Chip
                                                        group={group}
                                                        setGroupID={getGroupID}
                                                        groupID={groupID}
                                                    />
                                                </div>


                                                <Grid
                                                    item
                                                >
                                                    <Paper
                                                        elevation={0}
                                                        style={{
                                                            border: "1px solid #25414E",
                                                            display: "flex",
                                                            direction: "rtl",
                                                            background: "#25414E !important",
                                                            marginRight: "20px",
                                                            marginLeft: "20px"
                                                        }}
                                                        className="BgSearchDashboard"
                                                        square={false}
                                                    >
                                                        <InputBase
                                                            sx={{
                                                                ml: 1,
                                                                flex: 1,
                                                                paddingX: "16px",
                                                                background: "#25414E !important",
                                                                color: "#fff"
                                                            }}
                                                            placeholder="جستجو"
                                                            // inputProps={{ 'aria-label': 'جستجو' }}
                                                            onChange={handleSearchInput}
                                                        />
                                                        <IconButton
                                                            type="button"
                                                            sx={{
                                                                color: "#9AAFC4",
                                                            }}
                                                            aria-label="search"

                                                        >
                                                            <SearchIcon />
                                                        </IconButton>
                                                    </Paper>
                                                </Grid>

                                                {leftItemsWithSearch?.map((item: any, i: any) => (item.groupId == groupID)
                                                    ? (

                                                        //</Grid>leftItemsWithSearch?.map((item: any, i: any) =>
                                                        <div
                                                            draggable={true}
                                                            onDragStart={() => setTheCurrentDraggedElement(item)}
                                                            key={item.i}
                                                            data-grid={item}
                                                            // className="block blockCardLeftSide"
                                                            id={"left" + item.i}
                                                            style={{ borderRadius: "5px", maxWidth: "350px", marginTop: "10px", marginLeft: "0px" }}
                                                        >
                                                            <LeftSideCard
                                                                title={collapsed ? "" : item.title}
                                                                pbiReportTypeId={item.pbiReportTypeId}
                                                            />
                                                        </div>) : (<></>)
                                                    // ((!dashboardItemView?.some((x: any) => (x.id === item.id && x.isDeleted != true))) && item.groupId == groupID) ? (
                                                    //     <div
                                                    //         draggable={true}
                                                    //         onDragStart={() => setTheCurrentDraggedElement(item)}
                                                    //         key={item.id}
                                                    //         data-grid={item}
                                                    //         // className="block blockCardLeftSide"
                                                    //         id={"left" + item.id}
                                                    //         style={{ borderRadius: "5px", maxWidth: "350px", marginTop: "10px", marginLeft: "0px" }}
                                                    //     >
                                                    //         <LeftSideCard
                                                    //             title={collapsed ? "" : item.title}
                                                    //             pbiReportTypeId={item.pbiReportTypeId}
                                                    //         />
                                                    //     </div>
                                                    // ) : (
                                                    //     <></>
                                                    // )
                                                )}

                                                <div style={{ position: "relative", backgroundColor: "#1E1E2D", width: "90%", height: "50px" }}>

                                                </div>

                                                <div style={{ position: "absolute", backgroundColor: "#1E1E2D", width: "100%", height: "55px", bottom: "0px" }}>
                                                    <DehazeIcon style={{ color: "#FFFFFF", marginRight: "10px", marginTop: "10px", marginBottom: "10px" }} onClick={() => setCollapsed(!collapsed)} />
                                                </div>
                                            </Grid>
                                        </>}

                                </div>
                            </Sidebar>
                        </Grid>
                        : <></>}

                    <Grid item xs={collapsed ? 11.7 : 8} md={collapsed ? 11.7 : 9.5} lg={collapsed ? 11.7 : 9.5}
                        id="rightSide">

                        {" "}
                        <Grid item xs={12} className={dashboardItemView != null && dashboardItemView != undefined && dashboardItemView.length > 0 ? '' : 'rightHeight'}>
                            <ReactGridLayout
                                className={dashboardItemView != null && dashboardItemView != undefined && dashboardItemView.length > 0 ? '' : 'rightHeight'}
                                layout={
                                    dashboardItemView} //{{ lg: rightItems, md: rightItems }}
                                isResizable={(createDashboard == true || updateDashboard == true || cloneDashboard == true) ? true : false}
                                // onDragStop={(layout, oldItem, newItem) =>
                                //     handleDrag(layout, oldItem, newItem)
                                // }
                                // onResizeStop={(layout, oldItem, newItem) =>
                                //     handleDrag(layout, oldItem, newItem)
                                // }
                                onLayoutChange={(layout) =>
                                    onLayoutChange(layout)
                                }
                                isDroppable={(createDashboard == true || updateDashboard == true || cloneDashboard == true) ? true : false}
                                // isDraggable={(createDashboard == true || updateDashboard == true || cloneDashboard == true) ? true : false}
                                onDrop={(createDashboard == true || updateDashboard == true || cloneDashboard == true) ? onDrop : undefined}
                            // style={(createDashboard == true || updateDashboard == true || cloneDashboard == true) ? { height: "700px" } : {}}
                            >
                                {dashboardItemView?.map((item: any, index: any) => (

                                    <div
                                        key={index}//{item.id}
                                        data-grid={item}
                                        id={"right" + index}//item.id}
                                        style={{ width: "500px !important", borderRight: "1px solid #C1C7CB", borderLeft: "1px solid #C1C7CB", borderBottom: "1px solid #C1C7CB", borderRadius: "2px", display: (item.isDeleted == undefined || item.isDeleted == false) ? "" : "none" }}
                                    >
                                        <UserDashboardItem index={index} item={item} deleteItem={(createDashboard == true || updateDashboard == true || cloneDashboard == true) ? deleteItem : null} updateMode={(createDashboard == true || updateDashboard == true || cloneDashboard == true) ? true : false} />
                                    </div>

                                ))}
                            </ReactGridLayout>
                        </Grid>
                    </Grid>
                </Grid>
            </div >

        </div >
    );

};

